/* eslint-disable import/no-unresolved */
import { styled } from 'styled-components';

export const SectionLogoCarousel = styled.section`
  padding: 20px 0;
  background-color: ${({ theme }) => theme.colors.defaultWhite};
  overflow-x: hidden;
  width: 100%;
  max-width: 100vw;
  box-sizing: border-box;

  @media (max-width: ${({ theme }) => theme.breakpoint?.tablet || '768px'}) {
    padding: 10px 0;
  }
`;

export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  padding: 10px 0;
  box-sizing: border-box;
  margin: 0;

  & > * {
    max-width: 100%;
  }
`;

export const CarouselTrack = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  gap: ${({ $spaceBetween }) => $spaceBetween}px;
  will-change: transform;
  min-width: 0;

  @media (max-width: ${({ theme }) => theme.breakpoint?.tablet || '768px'}) {
    gap: 10px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint?.mobile || '480px'}) {
    gap: 8px;
  }
`;

export const GradientLeft = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 34px;
  background: linear-gradient(
    to right,
    ${({ theme }) => theme.colors.defaultWhite || '#ffffff'} 0%,
    rgba(255, 255, 255, 0.8) 30%,
    rgba(255, 255, 255, 0) 100%
  );
  z-index: 10;
  pointer-events: none;

  @media (max-width: ${({ theme }) => theme.breakpoint?.tablet || '768px'}) {
    width: 60px;
  }
`;

export const GradientRight = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 34px;
  background: linear-gradient(
    to left,
    ${({ theme }) => theme.colors.defaultWhite || '#ffffff'} 0%,
    rgba(255, 255, 255, 0.8) 30%,
    rgba(255, 255, 255, 0) 100%
  );
  z-index: 10;
  pointer-events: none;

  @media (max-width: ${({ theme }) => theme.breakpoint?.tablet || '768px'}) {
    width: 60px;
  }
`;

export const LogoSlide = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0 20px;
  height: 100%;
  opacity: 0.6;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 1;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint?.tablet || '768px'}) {
    padding: 0 10px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint?.mobile || '480px'}) {
    padding: 0 8px;
  }
`;

export const LogoLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  cursor: pointer;
`;

export const LogoImage = styled.img`
  height: 60px;
  width: auto;
  object-fit: contain;
  filter: grayscale(100%);
  opacity: 0.8;
  transition: all 0.3s ease;

  ${LogoSlide}:hover & {
    filter: grayscale(0%);
    opacity: 1;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint?.tablet || '768px'}) {
    height: 40px;
  }
`;
